export const DATA_TAXPAYER = "Datos del Contribuyente";
export const DATA_PAYER = "Datos del Pagador";
export const CUIT_CUIL = "CUIT/CUIL";
export const NAME = "(*) Apellido Nombre / Razón Social";
export const RESIDENCE = "(*) Domicilo";
export const MAIL = "Mail";
export const SAME_DATA = "Los datos son los mismos que los del contribuyente";
export const NEXT = "Siguiente";
